module.exports = __webpack_public_path__ + "static/media/halifax.8dd57043.svg";